import { Injectable } from '@angular/core';
import type { MegaplanCredentialsFindInterface } from '@zaoblako/shared/modules/integration/dtos/megaplan/megaplan.credentials.find.dto';
import type { MegaplanCredentialsFormInterface } from '@zaoblako/shared/modules/integration/dtos/megaplan/megaplan.credentials.form.dto';
import type { MegaplanProgramFindInterface } from '@zaoblako/shared/modules/integration/dtos/megaplan/megaplan.program.find.dto';
import type { MegaplanProgramFormInterface } from '@zaoblako/shared/modules/integration/dtos/megaplan/megaplan.program.form.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IntegrationMegaplanService extends BaseService {
  protected baseUrl = '/integration/megaplan';

  public credentials(body: MegaplanCredentialsFormInterface): Observable<MegaplanCredentialsFindInterface> {
    return this.http.post<MegaplanCredentialsFindInterface>(`${this.baseUrl}/credentials`, body);
  }

  public getIntegration(): Observable<MegaplanCredentialsFindInterface> {
    return this.http.get<MegaplanCredentialsFindInterface>(`${this.baseUrl}/credentials`);
  }

  public deleteIntegration(): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/credentials`);
  }

  public getPrograms(): Observable<MegaplanProgramFindInterface[]> {
    return this.http.get<MegaplanProgramFindInterface[]>(`${this.baseUrl}/program`);
  }

  public getProgramById(id: number): Observable<MegaplanProgramFindInterface> {
    return this.http.get<MegaplanProgramFindInterface>(`${this.baseUrl}/program/${id}`);
  }

  public editProgram(id: number, body: MegaplanProgramFormInterface): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/program/${id}`, body);
  }

  public synchronize(): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/synchronize`, null);
  }
}
